import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";

import TopBar from "./Components/TopBar";
import RegionMap from "./Components/RegionMap";
import Graphs from "./Components/Graphs";
import getForecast from "./mongodb-connect";
import CustomAuthenticator from "./Components/CustomAuthenticator";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";

export const DataContext = React.createContext(false);

function App({ region }) {
  const { t } = useTranslation();
  const { REACT_APP_ENVIRONMENT } = process.env;
  const appRegionName = region.name[0].toUpperCase() + region.name.substring(1);

  const [data, setData] = useState(null);
  const [user, setUser] = useState(null);
  const [showSignIn, setShowSignIn] = useState(region.requireSignIn);
  const [loading, setLoading] = useState(true);

  let env =
  REACT_APP_ENVIRONMENT && REACT_APP_ENVIRONMENT === 'production'
      ? "gold"
      : "test";

  const authStateChanged = (user) => {
    setData(null);
    setUser(user);
    setLoading(false);
    setShowSignIn(false);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      let user = null;
      if (region.showSignIn) {
        user = await Auth.currentAuthenticatedUser().catch(() => setLoading(false));
      }
      setLoading(false);
      setUser(user);
    })();

    document.title = t('title', {region: appRegionName});
    generateManifest();
  }, []);

  useEffect(() => {
    if (!loading) {
      if (user) {
        let regions = user.signInUserSession.accessToken.payload["cognito:groups"];
        regions = regions.filter((x) => x.includes(region.name));
        regions &&
        getForecast(regions[0], env).then((response) => {
          setData(response.data);
        }).catch(function(error) {
          // @TO_DO: throw in 500 page here
          console.log(error);
        });
      } else {
        const forecastRegion = region.subregions ? `${region.name}-${region.subregions[0]}` : region.name;
        getForecast(forecastRegion, env).then((response) => {
          setData(response.data);
        }).catch(function(error) {
          // @TO_DO: throw in 500 page here
          console.log(error);
        });
      }
    }
  }, [user, loading]);

  const generateManifest = () => {
    const manifest = {
      short_name: `Fruit Fly Forecast - ${appRegionName}`,
      name: `Fruit Fly Forecast - ${appRegionName}`,
      icons: [
        {
          src: `${window.location.origin}/favicon.ico`,
          sizes: "48x48",
          type: "image/x-icon"
        },
        {
          src: `${window.location.origin}/logo192.png`,
          type: "image/png",
          sizes: "192x192"
        },
        {
          src: `${window.location.origin}/logo512.png`,
          type: "image/png",
          sizes: "512x512"
        }
      ],
      start_url: window.location.href,
      id: "/",
      display: "standalone",
      theme_color: "#000000",
      background_color: "#ffffff",
      description: "The RapidAIM Fruit Fly Pressure Forecast"
    };

    const link = document.createElement('link');
    link.rel = 'manifest';
    
    link.href = `data:application/json;base64,${window.btoa(JSON.stringify(manifest))}`;
    document.head.appendChild(link);
  }

  return (showSignIn && !user) ? (
    <CustomAuthenticator allowSignUp={region.allowSignUp} authStateChanged={authStateChanged} setLoading={setLoading} />
  ) : data ? (
    <main>
      <DataContext.Provider value={data}>
        <TopBar
          user={user}
          setShowSignIn={setShowSignIn}
          action={() => {
            Auth.signOut().then(async () => {
              window.location.href = `/${region.name}`;
            });
            setData(null);
            setShowSignIn(region.requireSignIn);
          }}
          setData={setData}
          env={env}
          region={region}
        />
        <RegionMap />
        <Graphs user={user} region={region}/>
      </DataContext.Provider>
    </main>
  ) : (
    <div style={{top: '40%', position: 'absolute', textAlign: 'center', width: '100%'}}>
      <h2>{t('loading', {region: appRegionName})}</h2>
      <Spinner variant='primary' role="status"/>
    </div>
  );
}

export default App;
